<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {SpaceTable} from "../../../lib/Table/SpaceTable";
    import EditButtonView from "../../../component/common/Button/EditButtonView.svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import {MessageStore} from "../../../store/MessageStore";
    import FontAwesomeView from "../../../component/common/Image/FontAwesomeView.svelte";

    const dispatcher = createEventDispatcher();

    export let space;
    let isLoading = false;

    onMount(() => {
    });

    function onClickEdit() {
        dispatcher('edit', {space: space});
    }

    function onClickPublicKey() {
        const paramMap = {};
        paramMap['id'] = space.id;

        const url = UrlUtil.createApiUrl("space/public_key", paramMap);
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log("SpaceResourceView", response);
            const body = response['body'];

            const publicKeyText = body['public_key_text'];

            MessageStore.showConfirmInformation("Public Key の内容", publicKeyText);

        });
    }

</script>

<tr class="space-setting-row-view">
    <td>
        <EditButtonView on:click={onClickEdit}/>

    </td>
    <td>{ space.id }</td>
    <td>{ space.unique_id }</td>
    <td>{ space.name }</td>
    <td>
        {#if space.description != null}
            { space.description }
        {/if}
    </td>
    <td>{ SpaceTable.GitRepositoryType.map[space.git_repository_type]  }</td>
    <td>
        {#if space.git_web_url != null}
            { space.git_web_url }
        {/if}
    </td>
    <td>
        {#if space.git_ssh_url != null}
            { space.git_ssh_url }
        {/if}
    </td>
    <td>
        {#if space.slack_notice_channel_id != null}
            { space.slack_notice_channel_id }
        {:else}
            設定なし
        {/if}
    </td>
    <td class="public-key-cell">
        <button class="small" on:click={onClickPublicKey}>
            <FontAwesomeView icon="key"/>
            公開鍵情報表示
        </button>
    </td>


</tr>
<style lang="scss">
    .space-setting-row-view {
        .public-key-cell {
            font-size: 0.5em;
        }

    }
</style>